import React from "react";
import { Route, Redirect, useHistory } from "react-router-dom";
import { authorizationService } from "../_services";
import { NAV_LINKS } from "../_constants";
import { AuthenticatedTemplate, UnauthenticatedTemplate } from "@azure/msal-react";

const PrivateRoute = ({ component: Component, isOnlyAdmin, ...rest }) => {
  const history = useHistory()
  React.useEffect(() => {
    if (!authorizationService.isAuthorizedUser()) {
      history.push(NAV_LINKS.LOGIN)
    } else {
      if (!!isOnlyAdmin) {
        if (!authorizationService.getAuthorizedUser().isAdmin) {
          history.push(NAV_LINKS.STUDY_BROWSER)
        }
      }
    }
  }, [])

  return (
    <React.Fragment>
      <AuthenticatedTemplate>
        <Route
          {...rest}
          render={(props) => {
            return <Component {...props} />;
          }}
        />
      </AuthenticatedTemplate>
      <UnauthenticatedTemplate>
        <Route
          {...rest}
          render={(props) => {
            return (
              <Redirect
                to={{ pathname: NAV_LINKS.LOGIN, state: { from: props.location } }}
              />
            );
          }}
        />
      </UnauthenticatedTemplate>
    </React.Fragment>
  )
};

export { PrivateRoute };
